import React, { useEffect, useState } from "react";
import styled, { withTheme } from "styled-components";
import Tabs from './casino-tab';
import AllGames from './all-games';
import Intl from '../../common/Intl'
import { withAppContext } from 'src/store/initAppContext';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { liveCasinosSEOData } from "src/config/seo_api";
import { MetaProps, SEOFooterCommon, SEOMetaCommon } from "src/components/SEOMetaCommon";
import { getGamesJsonData } from "src/util/gameDataLoader";
import Spinner from "src/components/common/Spinner";
import { addressablePxlPageView } from "src/util/addressablePxl";
// Provider Icons for Live Casino, Slot Games, Bingo, Teenpatti---------------------------------
export const allIcon = `${'/static/media/AllProviderIcon.ab512083.png'}`;
export const netentIcon = `${'/static/media/netent.png'}`;
// export const betsoftIcon = `${'/static/media/Betsofticon.png'}`;
export const tvBetIcon = `${'/static/media/tvbet_icon.png'}`;
export const superSpadeIcon = `${'/static/media/superspade.png'}`;
export const ezugiIcon = `${'/static/media/ezugi_icon.png'}`;
export const evolutionIcon = `${'/static/media/evolution_icon.png'}`;
export const bettvIcon = `${'/static/media/bettv.png'}`;
export const agIcon = `${'/static/media/amazing_gaming.png'}`;
export const supernowaIcon = `${'/static/media/supernowa.png'}`;
export const spribeIcon = `${'/static/media/spribe_icon.png'}`;
export const sexygamingIcon = `${'/static/media/sexygamingIcon.png'}`;

function CasinoTabGames(props) {
    const { app: { brandId }, theme: { config } } = props;
    const { showAPISEOData } = config;

    const location = useLocation();
    const { provider, id } = useParams();

    //Next Change : unique URL for each game.
    const navigate = useNavigate()
    const state:any = location.state || {};
    const action = state.play;
    //END : unique URL for each game.

    const [gameData, setGameData] = useState({});
    const [casinoGames, setCasinoGames] = useState([]);
    const [filteredData, setfilteredData] = useState([]);
    const [providerList, setProviderList] = useState([]);
    const [providerTab, setProviderTab] = useState([]);
    const [providerIcons, setProviderIcons] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [seoObjects, setseoObjects] = useState({} as MetaProps);

    const getLastqueryString = location.pathname.split("/").pop();

    useEffect(() => {
        //need to remove play state on refresh
        if(action){
           navigate(location.pathname) 
        }
    }, [])
    
    useEffect(() => {
        const loadGames = async () => {
            try {
                const data = await getGamesJsonData("casinogames", brandId);
                setGameData(data);

                const { providers = [], gameData: games = [] } = data;

                // Set providerList
                const providerCategoryList = providers.map((ele: any) => ele.category);
                setProviderList(providerCategoryList);

                // Set provider Icons tab buttons
                const iconList = providers.map((ele: any) => ({
                    id: ele.id,
                    name: <Intl langKey={ele.displayKey} />,
                    icon: ele.icon,
                }));
                setProviderIcons(iconList);

                // Set tab names
                const tabNames = iconList.map((ele: any) => ele.name);
                setProviderTab(tabNames);

                // Set games
                setCasinoGames(games);
                setfilteredData(games);
            } catch (err) {
                console.error("Failed to load game data:", err);
            } finally {
                setLoading(false);
            }
        };

        loadGames();
        //addressablePxl
        addressablePxlPageView(brandId);
        
        window.scrollTo(0, 0);
    }, [brandId])

     //for SEO
    useEffect(() => {
    if (showAPISEOData) {
        const getSeoData = liveCasinosSEOData();
        const pathName = location.pathname;

        getSeoData.then(resp => {
        const { objects } = resp;
        const seoData = objects.find((obj: any) => {
            const { metadata = {} } = obj;
            if (metadata.pathname && metadata.pathname === pathName) {
            return obj;
            }

        }) || {};

        const { metadata = {} } = seoData;
        setseoObjects(metadata);

        }).catch(error => console.log(`[${pathName}]:Error in SEO API`))

    }
    }, [provider]);

    const searchData = (val: any) => {

        //Next Change : unique URL for each game.
         if(action) return ;
        //END : unique URL for each game.

        setSearch(val);

        if (val !== "") {

            // Old Function with out the slug handle
            // let _val = val && val.replace(/[\_\-\'\s]/gi, '');
            // const filteredItems = casinoGames.filter((item) => {
            // const { game = '', catagoryName = '', type = '', slug = '' } = item;

            // // Normalize the fields by removing unwanted characters and converting to lowercase
            // const normalizedGame = game.replace(/[\_\-\'\s]/gi, '').toLowerCase();
            // const normalizedCategoryName = catagoryName.replace(/[\_\-\'\s]/gi, '').toLowerCase();
            // const normalizedType = type.replace(/[\_\-\'\s]/gi, '').toLowerCase();
            // const normalizedSlug = slug.replace(/[\_\-\'\s]/gi, '').toLowerCase();

            // // Check if the cleaned-up field values start with the normalized search value
            // return (
            //     normalizedGame.includes(_val) || 
            //     normalizedCategoryName.includes(_val) || 
            //     normalizedType.includes(_val) || 
            //     normalizedSlug.includes(_val)
            // );


            // Clean up search value and item fields for better comparison
            // let type = item.type.toLowerCase() && item.type.replace(/[\_\-\'\s]/gi, '');
            // let slug = item.slug ? item.slug.replace(/[\_\-\'\s]/gi, '') : '';
            // let category = item.catagoryName ? item.catagoryName.replace(/[\_\-\'\s]/gi, '') : '';


            // // Check if either type or slug matches the search value
            // if (type.toLowerCase().includes(_val.toLowerCase()) || slug.toLowerCase().includes(_val.toLowerCase())) {
            //     return item;
            // }
            // else if ((item.game.replace(/[\_\-\'\s]/gi, '').toLowerCase()).startsWith(_val.toLowerCase())) {
            //     //searchOn = 'catagoryName'
            //     return item;
            //   }
            //   else if ((category.toLowerCase()).startsWith(_val.toLowerCase())) {
            //     //searchOn = 'catagoryName'
            //     return item;
            //   }
            //  else {
            //     const {platformCode, ...rest } = item;
            //     console.log('AAAAA-rest',rest);
            //     console.log('AAAAAA-',Object.values(rest).join('').toLowerCase().includes(val.toLowerCase()))
            //     // Fallback: Search through all other fields in the object
            //     return Object.values([platformCode]).join('').toLowerCase().includes(val.toLowerCase());
            // }


            let _val = val && val.replace(/[\_\-\.\'\s]/gi, '').toLowerCase();
            const filteredItems = casinoGames.filter((item) => {
                const { game = '', catagoryName = '', type = '', slug = '' } = item;
                const normalizedGame = game.replace(/[\_\-\.\'\s]/gi, '').toLowerCase();
                const normalizedCategoryName = catagoryName.replace(/[\_\-\'\s]/gi, '').toLowerCase();
                const normalizedType = type.replace(/[\_\-\'\s]/gi, '').toLowerCase();

                // Additional condition added for Handle slug as either string or array
                const slugList = Array.isArray(slug) ? slug : [slug];
                const normalizedSlugs = slugList.map(s =>
                    s.replace(/[\_\-\'\s]/gi, '').toLowerCase()
                );

                return (
                    normalizedGame.includes(_val) ||
                    normalizedCategoryName.includes(_val) ||
                    normalizedType.includes(_val) ||
                    normalizedSlugs.some(s => s.includes(_val))
                );
            });

            setfilteredData(filteredItems);
        } else {
            // Reset to original data when search input is empty
            setfilteredData(casinoGames);
        }
    };

    const budgetData = () => {

    }

    return (
        <>
            {showAPISEOData && (<SEOMetaCommon metaData={seoObjects} />)}

            {loading ? (
                <Spinner />
            ) : (
                <CasinoWrapper>
                    <TabListSection>
                        <Tabs
                            searchText={search}
                            providerIcons={providerIcons}
                            tabs={providerTab}
                            onSearch={searchData}
                            isTabsHidden={false}
                            budgetClick={budgetData}
                            minWidthInContent={"initial"}
                            providerList={providerList}
                            render={(index: any) => {
                                const selectedProvider = providerList[index];
                                const isAllGames = !selectedProvider || selectedProvider === 'all';

                                const filteredGameData = isAllGames ? filteredData
                                    : filteredData.filter((game) => (game.type || '').toLowerCase() === selectedProvider.toLowerCase());

                                return <AllGames data={filteredGameData} key={selectedProvider}/>
                            }}
                        />
                    </TabListSection>
                </CasinoWrapper>
            )}

            {/* New SEO Footer */}
            {showAPISEOData && <SEOFooterCommon footer_title={seoObjects['seo_footer_title_(h1)']} footer_content={seoObjects['seo_footer_content']} />}
        </>
    )
}


export default withAppContext(withTheme(CasinoTabGames));

const CasinoWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
`;

const TabListSection = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    
`;
